import React from 'react'
import {BaseButton, Center, Stack, Text} from '../../../vanilla'
import {Link} from '../../../components/link'

const EmptyCart = () => {
  return (
    <Center flex="1" paddingTop={['0px', '12px']}>
      <Stack align="center" spacing={['12px', '44px']}>
        <Text as="h1" variant="heading5">
          Your basket is currently empty
        </Text>
        <BaseButton as={Link} to="/" variant="outlineDark" size="sm" data-test-selector="continue-shopping-button">
          <Text variant="unstyled" fontSize="inherit" color="gray800">
            Continue Shopping
          </Text>
        </BaseButton>
      </Stack>
    </Center>
  )
}

export default EmptyCart
